export const COMPLAINT_GRIEVANCES = "/grievances";
export const GRIEVANCES_SEARCH = "/grievances/search"
export const COMPLAINT_SEARCH = "/complaints/search"
export const EMPLOYEES_SEARCH = "/employees/search"
export const EMPLOYEES_GetExportList = "/complaints/GetExportList"
export const CLIENT_REVIEW = "/grievances/clientreview"
export const CLIENTS = "/clients"
export const COMPLAINT_MULTI = "/complaints/multi"
export const LEGAL_SEARCH = "/Legal/search"
export const LEGAL_STATUS ="/Legal/Status"
export const LEGAL_CASETYPES ="/Legal/CaseTypes"